<div class="dt">
  <div class="dt__scroll">
    <table class="dt__table">
      <thead>
        <tr>
          <th *ngFor="let column of columns"
            [class.dt__sticky]="column.sticky"
            [class.text-center]="column.align === 'center'"
            [class.text-right]="column.align === 'right'">
            {{ column.header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows; trackBy: trackBy">
          <td *ngFor="let column of columns"
            [class.dt__sticky]="column.sticky"
            [class.text-center]="column.align === 'center'"
            [class.text-right]="column.align === 'right'">
            <ng-container *ngIf="cellTemplateFor(column.key) as template; else plainCell">
              <ng-container *ngTemplateOutlet="template; context: { row: row, value: columnValue(row, column.key) }"></ng-container>
            </ng-container>
            <ng-template #plainCell>{{ columnValue(row, column.key) ?? '--' }}</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!loading && rows.length === 0" class="dt__empty">
    {{ emptyMessage }}
  </div>

  <div class="dt__footer" *ngIf="meta && meta.total > 0">
    <span class="dt__results-label">Showing {{ rangeStart }} to {{ rangeEnd }} of {{ meta.total }} results</span>

    <div class="dt__pagination" *ngIf="meta.last_page > 1">
      <button class="dt__page-btn" [disabled]="meta.current_page === 1" (click)="goToPage(meta.current_page - 1)"
        aria-label="Previous page">
        <i class="sd sd-chevron-left" aria-hidden="true"></i>
      </button>

      <ng-container *ngFor="let page of pageNumbers">
        <span *ngIf="page === '...'" class="dt__page-ellipsis">…</span>
        <button *ngIf="page !== '...'" class="dt__page-btn" [class.dt__page-btn--active]="page === meta.current_page"
          [attr.aria-current]="page === meta.current_page ? 'page' : null" (click)="goToPage(page)">
          {{ page }}
        </button>
      </ng-container>

      <button class="dt__page-btn" [disabled]="meta.current_page === meta.last_page"
        (click)="goToPage(meta.current_page + 1)" aria-label="Next page">
        <i class="sd sd-chevron-right" aria-hidden="true"></i>
      </button>
    </div>

    <div class="dt__page-size">
      <label class="dt__page-size-label" for="dtPageSize">Rows per page</label>
      <div class="dt__page-size-control">
        <select id="dtPageSize" class="dt__page-size-select" [value]="pageSize ?? meta.per_page" (change)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
        </select>
        <i class="sd sd-chevron-down dt__page-size-icon" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
